import React from 'react';

export function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-[#FF6B35] rounded-lg flex items-center justify-center">
                <i className="ri-hammer-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold">RW Construction</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-4">
              Licensed general contractor serving Las Vegas Valley with over 20 years of experience in pool repair, synthetic grass, pavers, and complete home remodeling.
            </p>
            <div className="flex gap-3 mb-4">
              <a href="https://www.facebook.com/profile.php?id=61588126166404" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
            <div className="inline-flex items-center gap-2 bg-[#FF6B35] px-4 py-2 rounded-lg">
              <i className="ri-translate-2 text-white text-lg"></i>
              <span className="text-white font-semibold text-sm">¡Hablamos Español!</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li>
                <a href="/services/pool-repair" className="text-white/70 hover:text-[#FF6B35] transition-colors text-sm cursor-pointer">
                  Pool Repair
                </a>
              </li>
              <li>
                <a href="/services/synthetic-grass" className="text-white/70 hover:text-[#FF6B35] transition-colors text-sm cursor-pointer">
                  Synthetic Grass
                </a>
              </li>
              <li>
                <a href="/services/pavers" className="text-white/70 hover:text-[#FF6B35] transition-colors text-sm cursor-pointer">
                  Pavers
                </a>
              </li>
              <li>
                <a href="/services/electrical" className="text-white/70 hover:text-[#FF6B35] transition-colors text-sm cursor-pointer">
                  Electrical
                </a>
              </li>
              <li>
                <a href="#services" onClick={(e) => { e.preventDefault(); document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-white/70 hover:text-[#FF6B35] transition-colors text-sm cursor-pointer">
                  All Services
                </a>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-lg font-bold mb-4">Service Areas</h4>
            <ul className="space-y-2">
              <li>
                <a href="/service-areas/las-vegas" className="text-white/70 hover:text-[#FF6B35] transition-colors text-sm cursor-pointer">
                  Las Vegas
                </a>
              </li>
              <li>
                <a href="/service-areas/henderson" className="text-white/70 hover:text-[#FF6B35] transition-colors text-sm cursor-pointer">
                  Henderson
                </a>
              </li>
              <li>
                <a href="/service-areas/summerlin" className="text-white/70 hover:text-[#FF6B35] transition-colors text-sm cursor-pointer">
                  Summerlin
                </a>
              </li>
              <li>
                <a href="#service-areas" onClick={(e) => { e.preventDefault(); document.getElementById('service-areas')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-white/70 hover:text-[#FF6B35] transition-colors text-sm cursor-pointer">
                  View All Areas
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-orange-400">Contact Us</h3>
            <div className="space-y-4">
              <a href="tel:7027606213" className="flex items-center gap-3 text-gray-300 hover:text-orange-400 transition-colors cursor-pointer group">
                <i className="ri-phone-fill text-orange-400 group-hover:scale-110 transition-transform"></i>
                <span>702-760-6213</span>
              </a>
              <a href="mailto:info@rwconstructionlv.com" className="flex items-center gap-3 text-gray-300 hover:text-orange-400 transition-colors cursor-pointer group">
                <i className="ri-mail-fill text-orange-400 group-hover:scale-110 transition-transform"></i>
                <span>info@rwconstructionlv.com</span>
              </a>
              <div className="flex items-start gap-3 text-gray-300">
                <i className="ri-map-pin-fill text-orange-400 mt-1"></i>
                <div>
                  <p className="text-white">526 S 7th St</p>
                  <p className="text-white">Las Vegas, NV 89101</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-col items-center md:items-start gap-2">
            <p className="text-white/60 text-sm">
              © 2024 RW Construction Las Vegas LLC. All rights reserved.
            </p>
            <p className="text-white/50 text-xs">
              RW Construction Las Vegas LLC Associates
            </p>
          </div>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/60 hover:text-[#FF6B35] text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
